import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { LocalDataSource } from 'ng2-smart-table';
import { tiens_phieuchi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'




const swal = require('sweetalert');
@Component({
  selector: 'app-tonghop-sinhsolieuquyettoan',
  templateUrl: './sinhsolieuquyettoan.component.html',
  styleUrls: ['./sinhsolieuquyettoan.component.scss'],
    providers: [ListService, Repository]
})


export class sinhsolieuquyettoanComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';

  public tTuNgay: string;
  public tDenNgay: string;
  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();
  Nam: number;
  LoaiBaoCao: number;
  public username: string;

  indLoading: boolean = false;
  public ngxCurrencyOptionsnam = {
    prefix: '',
    thousands: '',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  source: LocalDataSource;

   
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor(  private repo: Repository) {
    }
  donviid: any;
  ngOnInit(): void {
   

    this.source = new LocalDataSource();

    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.username = crru.user_name;

      this.Nam = this.TuNgay.getFullYear();
      if (this.TuNgay.getFullYear() === crru.nam_ke_toan) {
        this.Nam = crru.nam_ke_toan-1;
      }
      else {
        this.Nam = crru.nam_ke_toan;
      }

      this.onLoad();

    }

    
    }

  settings = {
    mode: 'external',
    selectMode: 'multi',
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    pager:{
      perPage: 1,
      display: false,
    },
    actions: {
    
      add: false,
      edit: false,
      delete: false,

      position: 'right',
    },
    columns: {

      DonVi: {
        name: 'DonVi',
        width: '200px',
        title: 'Đơn vị ',

      },
      //NgayNhap: {
      //  name: 'NgayNhap',
      //  width: '110px',
      //  title: 'Ngày nhập',
      //  type: 'custom',
      //  renderComponent: DateViewComponent,
      //  //onComponentInitFunction: (instance) => {
      //  //  instance.save.subscribe(row => {
      //  //    console.log(row);
      //  //    this.editdata(row.Id);
      //  //  });
      //  //}
      //},
      Nam: {
        name: 'Nam',
        title: 'Năm',
      },
      NguoiNhap: {
        name: 'NguoiNhap',
        title: 'Người nhập',
      },
      Chot: {
        name: 'Chot',
        title: 'Khóa số liệu',
      },
      TrangThai: {
        name: 'TrangThai',
        title: 'Trạng thái',
      },
    },
  };
 
  selectedRows: any;
  loadDataInit(loaibc: number)
  {
    this.LoaiBaoCao = loaibc;
    this.selectedRows = [];
    this.onLoad();
  
  }

  changeNam(value) {
    this.onLoad();
  }

    keyTenPress(event: any) { 
      
  }
 

  public onLoad() {
  let user="";
    user = this.username.replace("@dms.gov.vn", "");

    this.repo.getRequest("api/bc01/GetDS_ThamSoSinhQT/" + this.Nam + '/' + this.LoaiBaoCao + '/' + user+'')
      .subscribe(response => {
        console.log(response);
        this.source.load(response);
        this.source.refresh();
      }); 
  }
  

  onRowSelect(event) {
    this.selectedRows = event.selected;
  }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    console.log(this.selectedRows);
    if (typeof this.selectedRows === "undefined" || this.selectedRows === null || this.selectedRows.length === 0) {
      swal('Cảnh báo!', "Bạn chưa chọn đơn vị để sinh số liệu quyết toán", 'warning');
      return;
    }
    else {
        var ds = null;
        this.selectedRows.forEach(
        (item) => {
          //console.log(item);
          if (ds === null)
            ds = item.Id;
          else
            ds = ds + ',' + item.Id;
        });
      $('#loading').show();
      let datatt = {
        Id: null,
        Type: null,
        Data: JSON.stringify({
            DonViId: this.donviid
          , UserName: this.username
          , Nam: this.Nam
          , Loai: this.LoaiBaoCao
          , Id: ds
        })
      };

      let api = "";
      if (this.LoaiBaoCao == 31)
        api = 'api/bc31/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 1)
        api = 'api/b01/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 3)
        api = 'api/b03/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 5)
        api = 'api/bc05mau1b02/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 6)
        api = 'api/bc06mau1b05/LayDuLieuTuDong_TatCa';

      if (this.LoaiBaoCao == 7 || this.LoaiBaoCao == 8 || this.LoaiBaoCao == 9  || this.LoaiBaoCao == 11)
        api = 'api/bc07/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 10)
        api = 'api/bc10/LayDuLieuTuDong_TatCa';

      if (this.LoaiBaoCao == 12)
        api = 'api/bc11/LayDuLieuTuDong_TatCa';

      if (this.LoaiBaoCao == 32)
        api = 'api/bc32/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 33)
        api = 'api/bc33/LayDuLieuTuDong_TatCa';
      if (this.LoaiBaoCao == 34)
        api = 'api/bc34/LayDuLieuTuDong_TatCa';
      

      this.repo.postRequest(api, datatt)
      .subscribe(datas => {
        $('#loading').hide();
        console.log("taitaissss");
        console.log(datas);
        if (datas === "1") {
          swal('Hoàn thành!', "Lấy dữ liệu thành công. Vui lòng tải lại trang", 'success');
          this.save.emit(this.selectedRows);
        }
        else
          
          swal('Lỗi!', datas, 'error');
      });

              
    }
      

  }
   
    
   

   


}
